



















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import DashLine from '@/components/common/edit/DashLine.vue';
import ImageUpload from '@/components/common/edit/ImageUpload.vue';
import FieldButton from '@/components/common/edit/FieldButton.vue';

import { QuillEditor, IntroItem } from '@/common/interface';
import { BargainParameterState, DegreeInterface } from '@/common/interface/bargain_type';
import { DEGREE_MAP } from '@/common/constants/bargain_type';

import getUrlParam from '@/common/utils/getUrlParam';
import { isMobile } from '@/common/utils/getPlaform';
import { getInputStyle } from '@/common/utils/getStyles';
import { resolveBoundaryValue } from '@/common/utils/format';
import { replaceString } from '@/common/utils/dealWithString';

import PrizeIntroList from './PrizeIntroList.vue';
import { majorNoticeText } from '@/common/constants/index';
import fetch from '@/common/api/fetch';

const INTERVAL_MIN = 0.1;
const INTERVAL_MAX = 999.9;
const MYCOUNT_MIN = 2;
const MYCOUNT_MAX = 200;

const IconVideo = 'https://image.xiaomaiketang.com/xm/rfxJ5Yidac.png';
const IconImg = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311697436.png?x-oss-process=image/resize,w_300,limit_0';
const FieldText = 'https://xiaomai-image.oss-cn-hangzhou.aliyuncs.com/1571311714121.png?x-oss-process=image/resize,w_300,limit_0';
interface Payload {
  item: IntroItem;
}
@Component({
  components: {
    'activity-label': ActivityLabel,
    'dash-line': DashLine,
    'image-upload': ImageUpload,
    'field-button': FieldButton,
    'prize-intro-list': PrizeIntroList
  }
})
export default class PrizeDescribe extends Vue {
  @Getter('section') section!: any;
  @Getter('version') version!: string;
  @Getter('chance') chance!: number; // 概率
  @Getter('count') count!: number; // 次数
  @Getter('leftQuota') leftQuota!: number;
  @Getter('bargainParameter') bargainParameter!: BargainParameterState;
  @Getter('chooseDegree') chooseDegree!: any;
  @Getter('orgId') orgId!: string;
  @Getter('sectionPrizeIntrosTextNum') sectionPrizeIntrosTextNum!: number;
  @Getter('sectionPrizeIntrosImgNum') sectionPrizeIntrosImgNum!: number;
  @Getter('xcxType') xcxType!: string;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;

  @Action('changeBargainParameter') changeBargainParameter!: Function;
  @Action('changeSectionInfo') changeSectionInfo!: Function;
  @Action('changeChooseDegree') changeChooseDegree!: Function;
  @Action('changeChanceCount') changeChanceCount!: Function;
  @Action('changeLeftQuota') changeLeftQuota!: Function;
  @Action('changeShowFooter') changeShowFooter!: Function;
  @Action('addSectionPrizeIntros') addSectionPrizeIntros!: Function;

  flag: boolean = false;
  pageType: string | undefined = getUrlParam('type');
  degreeMap: DegreeInterface = DEGREE_MAP;
  isMobile: Function = isMobile;
  replaceString: Function = replaceString;
  FieldText: string = FieldText;
  IconImg: string = IconImg;
  videoList: any = [];
  showVideo: Boolean = false;
  selectItem: any = {};

  get inputStyle() {
    const { inputFontColor, inputBackgroundColor } = this.section;
    return getInputStyle(inputFontColor, inputBackgroundColor);
  }

  get prizeImageList(): Array<string> {
    let prizePic: string = this.section.prizePic;
    return prizePic.split('@').filter((value: string) => {
      if (value) {
        return value;
      }
    });
  }
  get myCount() {
    return this.count;
  }

  set myCount(val: number) {
    this.calculateChance(val);
    this.handleResolveCutPrice(val);
  }

  handleResolveCutPrice(val: number) {
    let { maxPrice, minPrice, maxCutPrice, minCutPrice } = this.bargainParameter;
    maxCutPrice = ((maxPrice - minPrice) * 3) / 2 / val;
    minCutPrice = (maxPrice - minPrice) / 2 / val;
    const payload = {
      minCutPrice: Number(minCutPrice.toFixed(2)),
      maxCutPrice: Number(maxCutPrice.toFixed(2))
    };
    this.changeBargainParameter(payload);
  }

  // 计算完成率
  calculateChance(count: number) {
    let chance = count === 1 ? 1 : 0;
    if (count >= 2 && count < 45) {
      chance = 0.96 - 0.018 * count;
    } else if (count >= 45) {
      chance = 0.8 / (count - 40);
    }

    const payload = {
      chance: Math.round(chance * 100),
      count: Math.round(count)
    };
    this.changeChanceCount(payload);
  }

  onEditorChange(quill: QuillEditor) {
    this.changeSectionInfo({
      value: quill.html,
      type: 'prizeDesc'
    });
  }

  // 修改奖品图片
  handleChangePrizeImage(imgUrl: string) {
    const payload = {
      value: imgUrl,
      type: 'prizePic'
    };
    this.changeSectionInfo(payload);
  }

  // 删除奖品图片
  handleDeletePrizeImage() {
    const payload = {
      value: '',
      type: 'prizePic'
    };
    this.changeSectionInfo(payload);
  }

  // 修改奖品图片
  handleChangePrizeImage1(imgUrl: string) {
    let prizePic: string = this.section.prizePic;
    prizePic = prizePic + '@' + imgUrl;
    const payload = {
      value: prizePic,
      type: 'prizePic'
    };
    this.changeSectionInfo(payload);
  }

  // 删除奖品图片
  handleDeletePrizeImage1(index: number) {
    const prizeImageList = Array.from(this.prizeImageList);
    prizeImageList.splice(index, 1);
    const payload = {
      value: prizeImageList.join('@'),
      type: 'prizePic'
    };
    this.changeSectionInfo(payload);
  }

  handleChangeInput(value: number, type: string) {
    if (type === 'prizeNum') {
      // 奖品数量一定要为整数，如果为小数的话保存的时候会报500，因为后端不接受小数类型的值
      this.changeLeftQuota(value);
      this.changeBargainParameter({ [type]: value });
    }

    if (type !== 'prizeNum') {
      this.changeBargainParameter({ [type]: value }).then(() => {
        this.handleCaculateChance();
      });
    }
  }

  handleInputBlur(value: number, type: string, hasDecimal: boolean = false) {
    // 判断是否需要保留小数点（课程数量不需要保留小数点，日常价/底价需要保留2位小数点）
    if (type !== 'intervalTime') {
      const _value = resolveBoundaryValue(value, hasDecimal);
      this.changeBargainParameter({ [type]: _value }).then(() => {
        if (['maxPrice', 'minPrice'].includes(type)) {
          // 设置日常价和底价之后，需要重新设置砍价次数
          this.handleCaculateChance();
        }
      });
    }

    if (type === 'intervalTime') {
      if (value < INTERVAL_MIN) {
        this.changeBargainParameter({ [type]: INTERVAL_MIN });
      } else if (value > INTERVAL_MAX) {
        this.changeBargainParameter({ [type]: INTERVAL_MAX });
      } else if (value <= INTERVAL_MIN && INTERVAL_MAX >= value) {
        this.changeBargainParameter({ [type]: Number(value).toFixed(1) });
      }
    }
  }

  handleMyCountBlur(value: number) {
    let _value = value;
    if (value < MYCOUNT_MIN) {
      _value = MYCOUNT_MIN;
    } else if (value > MYCOUNT_MAX) {
      _value = MYCOUNT_MAX;
    } else if (value <= INTERVAL_MIN && MYCOUNT_MAX >= value) {
      _value = Math.round(value);
    }

    this.calculateChance(_value);
    this.handleResolveCutPrice(_value);
  }

  handleCaculateChance() {
    const bargainParameter = this.bargainParameter;
    const { maxPrice, minPrice, maxCutPrice, minCutPrice } = bargainParameter;
    const count = ((maxPrice - minPrice) * 2) / (maxCutPrice + minCutPrice);
    this.calculateChance(count);
  }

  handleAddTextIntro(): void {
    if (this.sectionPrizeIntrosTextNum < 10) {
      const introItem: IntroItem = {
        type: 'text',
        value: ''
      };
      const payload: Payload = {
        item: introItem
      };
      this.addSectionPrizeIntros(payload);
    } else {
      Vue.$toast.info('最多添加10个文本');
    }
  }
  handleAddImage(imgUrl: string): void {
    if (this.sectionPrizeIntrosImgNum < 10) {
      const filedImgs = document.getElementsByClassName('field-img-upload');
      Array.from(filedImgs).forEach((img: any) => {
        img.value = '';
      });
      const introItem: IntroItem = {
        type: 'img',
        value: imgUrl
      };
      const payload: Payload = {
        item: introItem
      };
      this.addSectionPrizeIntros(payload);
    } else {
      Vue.$toast.info('最多添加10个图片');
    }
  }
  handleShowVideo(): void {
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }
    this.getVideoList();
    this.showVideo = true;
    this.changeShowFooter(false);
  }
  selectVideo(): void {
    if (this.selectItem.videoUrl) {
      const introItem: IntroItem = {
        type: 'video',
        value: this.selectItem.videoUrl,
        coverUrl: this.selectItem.coverUrl
      };
      const payload: Payload = {
        item: introItem
      };
      this.showVideo = false;
      this.addSectionPrizeIntros(payload);
      this.changeShowFooter(true);
    }
  }
  handleToggleSelectItem(item: object): void {
    if (this.selectItem === item) {
      this.selectItem = {};
    } else {
      this.selectItem = item;
    }
  }
  handleCloseVideo(): void {
    this.selectItem = {};
    this.showVideo = false;
    this.changeShowFooter(true);
  }
  getVideoList() {
    const instId = getUrlParam('instId');
    const activityId = getUrlParam('broadcastId');
    if (instId) {
      return fetch.Sales('anon/businessShow/getCustomizeVideoList', { instId }).then((res: any) => {
        this.videoList = res.result || [];
        this.videoList.map((item: any) => {
          item.bag = item.coverUrl || item.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast';
        });
        (this.section.prizeIntros || []).map((item: any) => {
          if (item.type == 'video') {
            this.selectItem = {
              videoUrl: item.value,
              coverUrl: item.coverUrl
            };
          }
        });
      });
    } else {
      return fetch.Sales('anon/businessShow/getCustomizeVideoList', { activityId }).then((res: any) => {
        this.videoList = res.result || [];
        this.videoList.map((item: any) => {
          item.bag = item.coverUrl || item.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast';
        });
        (this.section.prizeIntros || []).map((item: any) => {
          if (item.type == 'video') {
            this.selectItem = {
              videoUrl: item.value,
              coverUrl: item.coverUrl
            };
          }
        });
      });
    }
  }
}
